export default __webpack_public_path__ + "static/m-fitness6-7022427fa2e064036b4789c3e0eeb25e.jpg";